import { render, staticRenderFns } from "./apply_protect.vue?vue&type=template&id=877999a4&scoped=true"
import script from "./apply_protect.vue?vue&type=script&lang=js"
export * from "./apply_protect.vue?vue&type=script&lang=js"
import style0 from "./apply_protect.vue?vue&type=style&index=0&id=877999a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877999a4",
  null
  
)

export default component.exports